module.exports = __webpack_public_path__ + "img/20201005_115109.9b7011d7.jpg";